import { node, string, bool } from 'prop-types'
import { Fragment } from 'react'
import Conditional from '../Conditional'
import StatusDot from '../StatusDot'
import { kuiperClassNames } from '../utils'

import './styles.scss'

/*
Menu sections are created and passed as children into the ScrollableMenu and
presented in the order given. In addition to the props listed here,
MenuSection also accepts customClassName and key. The key is expected to be
unique and is used to make scrolling work even if additional sections are added.
It is up to the developer to set those keys. In some cases (PCM), the key is
arbitrarily set by the developer. In other cases (PlacementsPreviwer), the
key comes from an object ID.
*/
const MenuSection = ({
  children,
  customClassName,
  description,
  title,
  sectionStatusDotPresent,
  sectionStatusDotStatus,
}) => (
  <Fragment>
    <h2>{title}</h2>
    <Conditional condition={sectionStatusDotPresent}>
      <StatusDot status={sectionStatusDotStatus} />
    </Conditional>
    <p>{description}</p>
    <div className={kuiperClassNames('section-content', customClassName)}>
      {children}
    </div>
  </Fragment>
)

MenuSection.propTypes = {
  children: node,
  customClassName: string,
  description: string,
  sectionStatusDotPresent: bool,
  sectionStatusDotStatus: string,
  sidebarStatusDotPresent: bool,
  sidebarStatusDotStatus: string,
  title: string,
}

MenuSection.defaultProps = {
  sidebarStatusDotPresent: false,
  sectionStatusDotPresent: false,
  sectionStatusDotStatus: 'warning',
}

export default MenuSection
